module.exports = {
  common: {
    instagramLink: "https://www.instagram.com/coldstoragesg/",
    facebookLink: "https://www.facebook.com/sg.coldstorage",
    youtubeLink: "https://www.youtube.com/channel/UCSjKnwdfRFumraG7tIp7Vpw",
    wellCenter: "Cold Storage help center",
    telegramLink: "https://t.me/coldstoragesg",
    searchPlaceholder: "Searching in Cold Storage"
  },
  footer: {
    aboutShop: "About us",
    followUs: "Follow us",
    coptyRight: "© Copyright 2024 Cold Storage Online. All Rights Reserved.",
    ourStory: "Our Story",
    ourStoryLink: "https://coldstorage.com.sg/d/duyem0YfBV.html",
    storeLocatorLink: "/store_locator",
    careersLink: "https://www.jobstreet.com.sg/en/companies/477493-dfi-retail-group/jobs",
    tel: "6891 8100",
    emailLink: "csonline@coldstorage.com.sg",
    privacyPolicyLink: "https://coldstorage.com.sg/d/cs7htgJar1.html",
    termsAndConditionsLink: "https://coldstorage.com.sg/d/pDjHuIvwCahmJYB.html",
    contactUsLink: "https://coldstorage.com.sg/en/d/GWVUOaSCbjdIM6ln.html",
    ourBrands: "Our Brands",
    ourCommitment: "Our Commitment",
    ourBrandsLink: "https://coldstorage.com.sg/d/IM6ghXm130J.html",
    ourCommitmentLink: "https://coldstorage.com.sg/d/kafQChK1w8RM.html",
    appStoreLink: "https://apps.apple.com/sg/app/cold-storage-grocery-delivery/id1566492557",
    goolePlayLink: "https://play.google.com/store/apps/details?id=com.rtasg.intl&hl=en_US"
  },
  page: {
    title: "Grocery Delivery"
  },
  productDetails: {
    freshnessInfo: "Cold Storage promises this item will stay fresh for {num} days, including the day of delivery."
  },
  order: {
    banner:
      "All orders are synced from the Cold Storage app. Some orders might be split, but we will deliver them together for each purchase.",
    syncedOrder: "Current order is synced from Cold Storage app.",
    goToAppTips: "Please go to our Cold Storage app and check more details"
  },
  orderDetails: {
    productdisabledTitle: "View item details with Cold Storage app"
  },
  cart: {
    rangeStandardDeliveryTitle:
      "The following items cannot be delivered to you, please enjoy the full shopping experience in our Cold Storage app",
    unRangeStoreGroupTitle:
      "The following items cannot be delivered to you with express delivery in the website yet, please enjoy the full shopping experience in our Cold Storage app",
    slaveStoreMsg:
      "Seamlessly check out items from other stores synced with your Cold Storage app on the Cold Storage website",
    slaveStoreTip: "View item details with Cold Storage app"
  },
  getTheApp: {
    description: "For an optimized mobile experience, shop in Cold Storage online shop now!"
  },
  header: {
    feedbackLink: "https://yuu.qualtrics.com/jfe/form/SV_8erEI4Mn8qdgDps",
    customerCareLink: "https://coldstorage.com.sg/d/GWVUOaSCbjdIM6ln.html"
  },
  notification: {
    appPushNotification: "App Push Notification",
    appTips: "Receive latest promotion update",
    smsNotification: "SMS",
    smsTips: "Get notified by SMS for the latest promotion",
    emailNotification: "Email Notification",
    emailTips: "Get notified by email for the latest promotion",
    operationSuccessful: "Operation Successful",
    operationFailed: "Operation Failed"
  }
}
